enum TransportType {
	BULK = 'bulk',
	CONTAINER = 'containers',
	LIQUID = 'liquid'
}

export default TransportType
